<template>
<div>
  <juTalepler></juTalepler>
</div>
</template>

<script>
import JuTalepler from "./Comp/juTalepler";
import JuKayit from "./Comp/juKayit";

export default {
  components: {JuKayit, JuTalepler},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Index.vue